import { processImageFile } from "./imageUpload";

function getUploadApiUrl() {
  const explicit = (process.env.REACT_APP_UPLOAD_API_URL || "").trim();
  if (explicit) return explicit;
  const sync = (process.env.REACT_APP_CONTENT_SYNC_URL || "").trim();
  if (sync) return sync.replace(/\/content\.php$/i, "/upload.php");
  return "";
}

/**
 * Uploads to server when REACT_APP_CONTENT_SYNC_URL + REACT_APP_CONTENT_SYNC_SECRET are set;
 * otherwise embeds as data URL (local dev / no PHP).
 */
export async function uploadImageToServer(file) {
  const uploadUrl = getUploadApiUrl();
  const secret = (process.env.REACT_APP_CONTENT_SYNC_SECRET || "").trim();

  if (!uploadUrl || !secret) {
    return processImageFile(file);
  }

  const body = new FormData();
  body.append("file", file);
  body.append("himmelstor_key", secret);

  const res = await fetch(uploadUrl, {
    method: "POST",
    credentials: "omit",
    headers: {
      "X-Himmelstor-Key": secret,
    },
    body,
  });

  let data = {};
  try {
    data = await res.json();
  } catch (_) {
    data = {};
  }

  if (!res.ok) {
    throw new Error(data.error || `Upload failed (${res.status})`);
  }
  if (!data.url) {
    throw new Error("Server did not return an image URL");
  }
  return data.url;
}
